<template>
  <v-card class="modal-principal">
    <v-card-title class="titulo">
      <span>Detalle devolución PAMI</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text
      style="height: 100%;"
      class="pa-0"
    >
      <v-data-table
        must-sort
        :headers="headers"
        :items="items"
        :pagination.sync="paginacion"
        :total-items="totalItems"
        :rows-per-page-items="itemsPorPagina"
        :loading="cargando"
        class="elevation-1"
      >
        <v-progress-linear
          v-slot:progress
          color="blue"
          indeterminate
          v-if="cargando"
        ></v-progress-linear>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left">{{ props.item.concepto_facturacion }}</td>
            <td class="text-xs-left">{{ props.item.periodo_prestacion }}</td>
            <td class="text-xs-right">{{ props.item.monto | currency }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <botones-cancelar-guardar
        v-bind:mostrar-guardar="false"
        v-on:alCancelar="cerrar"
      ></botones-cancelar-guardar>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { formatoFecha, nombreCentro } from '@/helpers/filtros'
import Modelo from '@/api/comprobante'
import BotonesCancelarGuardar from '@/components/Botones/BotonesCancelarGuardar'

export default {
  name: 'FacturacionCentroDetalleDevolucionPami',
  components: {
    BotonesCancelarGuardar
  },
  filters: {
    formatoFecha,
    nombreCentro
  },
  props: {
    comprobanteId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      filtros: {
        search: null
      },
      totalItems: 0,
      headers: [
        { text: 'Concepto', value: 'concepto_facturacion', sortable: false },
        { text: 'Período', value: 'periodo_prestacion', sortable: false },
        {
          text: 'Monto',
          value: 'monto',
          sortable: false,
          align: 'right'
        }
      ],
      items: [],
      paginacion: {},
      itemsPorPagina: [20, 50, 100],
      cargando: false,
      cargandoConceptos: false,
      referencia: {
        type: String,
        required: true
      },
      itemSeleccionado: null
    }
  },
  watch: {
    paginacion: {
      handler () {
        this.filtrarDatos()
      },
      deep: true
    }
  },
  mounted () {
    let vm = this
    vm.filtrar()
  },
  methods: {
    filtrar () {
      let vm = this
      vm.filtros.page = 1
      vm.filtrarDatos()
    },

    filtrarDatos () {
      let vm = this
      let _filtros = _.assign({}, vm.filtros)

      if (vm.cargando) {
        return false
      }

      _filtros.page = vm.paginacion.page
      _filtros.perPage = vm.paginacion.rowsPerPage
      _filtros.orderBy = vm.paginacion.sortBy
      _filtros.sortedBy = vm.paginacion.descending ? 'desc' : 'asc'

      vm.cargando = true
      vm.metodoFiltrar(_filtros).then(
        data => {
          vm.items.lenght = 0
          vm.items = data.data
          vm.totalItems = data.total
          vm.cargando = false
        },
        error => {
          this.$emit('mostrarError', error)
          vm.cargando = false
        }
      )
    },
    cerrar () {
      this.$emit('alCerrar')
    },

    metodoFiltrar (filtros) {
      let vm = this
      filtros.comprobanteId = vm.comprobanteId
      return Modelo.obtenerDetalleDevolucionPami(filtros)
    }
  }
}
</script>
<style scoped></style>
